import(/* webpackMode: "eager" */ "/codebuild/output/src935075867/src/app/home/page.tsx");
